exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clazz_courseBox_14av1{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-justify-content: space-around;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n    width: 1200px;\n    margin: 80px auto;\n    padding-bottom: 50px;\n}", ""]);

// exports
exports.locals = {
	"courseBox": "clazz_courseBox_14av1"
};